/*
цель метрики javascript-событие

counter
номер счетчика number

id
идентификатор цели на элементе string
*/

let counter = 49821988;
export const yandexReachGoal = (id) => {
    try {
        window.ym(counter, 'reachGoal', id)
    } catch (err) {
        console.log(err);
    }

}